<loren-page-content>
    <mat-card-title>{{"infrastructure.locations" | transloco }}</mat-card-title>

    <div class="loren-map-container">
        <div class="loren-map-section" [style.flex]="lastSelectedAsset ? '1' : '1'">
            <div
                    leaflet
                    #mapWrapper
                    [style.width]="'100%'"
                    [style.height]="(mapHeight$ | async) + 'px'"
                    (leafletMapMoveEnd)="handleMapMove()"
                    (leafletMapReady)="onMapReady($event)"
                    [leafletOptions]="options"></div>

            <loren-layer-selection
                *lorenFeatureToggle="lorenFeatures.GENERIC_MAP_LAYERS_VISUALIZATION"
                [allMapLayers]="allMapLayers"
                [lastSelectedLayers]="lastSelectedLayers"
                [buttonBottomOffset]="layerBtnBottomOffset"
                [btnLook]="'layer-selection-btn'"
                (finishLayerSelection)="handleLayerSelection($event)">
            </loren-layer-selection>
        </div>

        @if (lastSelectedAsset) {
            <loren-map-details-sidepanel
                    [asset]="lastSelectedAsset"
                    [mapHeight]="(mapHeight$ | async) + 'px'"
                    (closed)="closeSidebar()"/>
        }
    </div>
</loren-page-content>
